export const MAX_CHILDREN = 48;
export const MAX_DEPTH = 9;
export const MAX_CATEGORIES_NESTED = 6;
export const MAX_CATEGORIES_NESTED_ROOT = 15;

export const SORT_OPTIONS = Object.freeze([
  {
    text: 'A -> Z',
    value: 'title',
  },
  {
    text: 'Z -> A',
    value: '-title',
  },
  {
    text: 'Old -> New',
    value: 'id',
  },
  {
    text: 'New -> Old',
    value: '-id',
  },
]);

export const ORDERING_MODES_NAMES = Object.freeze({
  email: 'Email',
  read_only: 'Read Only',
  on_site: 'On Site Fulfillment',
});

export const IRD_NODE_TYPES = Object.freeze({
  ird_items: 'ird_items',
  ird_categories: 'ird_categories',
});
